{
  "common.action.add": "Add",
  "common.action.apply": "Apply",
  "common.action.back": "Back",
  "common.action.cancel": "Cancel",
  "common.action.clear": "Clear",
  "common.action.close": "Close",
  "common.action.confirm": "Confirm",
  "common.action.continue": "Continue",
  "common.action.copy": "Copy",
  "common.action.create": "Create",
  "common.action.delete": "Delete",
  "common.action.details": "Details",
  "common.action.download": "Download",
  "common.action.duplicate": "Duplicate",
  "common.action.edit": "Edit",
  "common.action.filter": "Filter",
  "common.action.forward": "Forward",
  "common.action.get_started": "Get started",
  "common.action.invite": "Invite",
  "common.action.learn_more": "Learn more",
  "common.action.moreActions": "More actions",
  "common.action.new": "New",
  "common.action.next": "Next",
  "common.action.okay": "Okay",
  "common.action.open": "Open",
  "common.action.paste": "Paste",
  "common.action.previous": "Previous",
  "common.action.refresh": "Refresh",
  "common.action.remove": "Remove",
  "common.action.rename": "Rename",
  "common.action.reset": "Reset",
  "common.action.save": "Save",
  "common.action.search": "Search",
  "common.action.send": "Send",
  "common.action.share": "Share",
  "common.action.show_less": "Show less",
  "common.action.show_more": "Show more",
  "common.action.sort": "Sort",
  "common.action.try_again": "Try again",
  "common.action.upload": "Upload",
  "common.board.deleteFailed": "Couldn't delete the card",
  "common.board.deleteMessage": "The card is deleted for everyone who uses this board.",
  "common.board.deleteNeedsWorkspace": "Open this board in the workspace to delete cards.",
  "common.board.deleteTitle": "Delete “{name}”?",
  "common.board.empty": "Nothing on the board yet",
  "common.board.loadError": "Couldn't load the board — {error}",
  "common.hint.keepTyping": "{count} more — keep typing to narrow",
  "common.hint.panTouch": "Drag to pan, pinch to zoom.",
  "common.hint.panWheel": "Wheel to pan, ⌘/Ctrl + wheel to zoom.",
  "common.language.change": "Change language",
  "common.language.lockedByWorkspace": "Interface language is set by the workspace",
  "common.language.setByWorkspace": "Set by the workspace",
  "common.monthLong.apr": "April",
  "common.monthLong.aug": "August",
  "common.monthLong.dec": "December",
  "common.monthLong.feb": "February",
  "common.monthLong.jan": "January",
  "common.monthLong.jul": "July",
  "common.monthLong.jun": "June",
  "common.monthLong.mar": "March",
  "common.monthLong.may": "May",
  "common.monthLong.nov": "November",
  "common.monthLong.oct": "October",
  "common.monthLong.sep": "September",
  "common.monthShort.apr": "Apr",
  "common.monthShort.aug": "Aug",
  "common.monthShort.dec": "Dec",
  "common.monthShort.feb": "Feb",
  "common.monthShort.jan": "Jan",
  "common.monthShort.jul": "Jul",
  "common.monthShort.jun": "Jun",
  "common.monthShort.mar": "Mar",
  "common.monthShort.may": "May",
  "common.monthShort.nov": "Nov",
  "common.monthShort.oct": "Oct",
  "common.monthShort.sep": "Sep",
  "common.pagination.label": "Pagination",
  "common.party.addAnyway": "Add anyway",
  "common.party.addFailed": "Could not add the client. Try again.",
  "common.party.addNew": "New client",
  "common.party.email": "Email",
  "common.party.idExists": "{name} already has this ID number. The existing client is chosen.",
  "common.party.kind": "Type",
  "common.party.kindCompany": "Company",
  "common.party.kindPerson": "Person",
  "common.party.label": "Client",
  "common.party.legalName": "Legal name",
  "common.party.loadFailed": "Could not load the list. Try again.",
  "common.party.name": "Name",
  "common.party.nameRequired": "Enter a name.",
  "common.party.personalId": "Personal ID",
  "common.party.phone": "Phone",
  "common.party.placeholder": "Choose a client",
  "common.party.searching": "Searching…",
  "common.party.similarName": "A client with a similar name exists: {name}.",
  "common.party.taxId": "Tax ID",
  "common.party.useExisting": "Use {name}",
  "common.state.active": "Active",
  "common.state.coming_soon": "Coming soon",
  "common.state.disabled": "Disabled",
  "common.state.draft": "Draft",
  "common.state.empty": "Empty",
  "common.state.enabled": "Enabled",
  "common.state.error": "Error",
  "common.state.loading": "Loading",
  "common.state.noMatches": "No matches",
  "common.state.optional": "Optional",
  "common.state.published": "Published",
  "common.state.required": "Required",
  "common.state.saved": "Saved",
  "common.state.saving": "Saving",
  "common.state.success": "Success",
  "common.state.warning": "Warning",
  "common.time.daysAgo": "{count} days ago",
  "common.time.hoursAgo": "{count} hours ago",
  "common.time.justNow": "just now",
  "common.time.minutesAgo": "{count} mins ago",
  "common.time.monthsAgo": "{count} months ago",
  "common.time.today": "Today",
  "common.time.weeksAgo": "{count} weeks ago",
  "common.time.yearsAgo": "{count} years ago",
  "common.time.yesterday": "Yesterday",
  "common.timeShort.days": "{count}d",
  "common.timeShort.hours": "{count}h",
  "common.timeShort.minutes": "{count}m",
  "common.timeShort.now": "now",
  "common.timeShort.weeks": "{count}w",
  "common.timeShortAgo.days": "{count}d ago",
  "common.timeShortAgo.hours": "{count}h ago",
  "common.timeShortAgo.minutes": "{count}m ago",
  "common.timeShortAgo.seconds": "{count}s ago",
  "common.timeShortAgo.weeks": "{count}w ago",
  "common.weekdayLong.fri": "Friday",
  "common.weekdayLong.mon": "Monday",
  "common.weekdayLong.sat": "Saturday",
  "common.weekdayLong.sun": "Sunday",
  "common.weekdayLong.thu": "Thursday",
  "common.weekdayLong.tue": "Tuesday",
  "common.weekdayLong.wed": "Wednesday",
  "common.weekdayShort.fri": "Fri",
  "common.weekdayShort.mon": "Mon",
  "common.weekdayShort.sat": "Sat",
  "common.weekdayShort.sun": "Sun",
  "common.weekdayShort.thu": "Thu",
  "common.weekdayShort.tue": "Tue",
  "common.weekdayShort.wed": "Wed"
}
